/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * The alert status of the ticket
 */
export enum TicketStatusAlert {
  NEW = 'new',
  OPEN = 'open',
  OPEN_OVERDUE = 'open_overdue',
  OPEN_OVERDUE_WARN = 'open_overdue_warn',
  IN_PROGRESS = 'in_progress',
  IN_PROGRESS_OVERDUE = 'in_progress_overdue',
  IN_PROGRESS_OVERDUE_WARN = 'in_progress_overdue_warn',
  CLOSED = 'closed',
}
